import script from "./DatasetStats.vue?vue&type=script&setup=true&lang=js"
export * from "./DatasetStats.vue?vue&type=script&setup=true&lang=js"

import "./DatasetStats.vue?vue&type=style&index=0&id=cfd9b468&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cfd9b468"]])

export default __exports__